import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh_CHT from './config/zh_CHT'
import en from './config/en'
import zh_CN from "./config/zh";
import ko_KR from "./config/ko_KR";
import vi_VN from "./config/vi_VN";
import ja_JP from "./config/ja_JP";
import ms_MY from "./config/ms_MY";
import th_TH from "./config/th_TH";
import pt_BR from "./config/pt_BR";
import ru_RU from "./config/ru_RU";
Vue.use(VueI18n)
const i18n = new VueI18n({
	messages: {
    zh_CN,
		en,
    zh_CHT,
    ko_KR,
		vi_VN,
    ja_JP,
    ms_MY,
    th_TH,
    pt_BR,
    ru_RU
	},

	locale: localStorage.getItem('locale') || 'en'
})



export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js